import { render, staticRenderFns } from "./FormularioComponent.vue?vue&type=template&id=53b111e8&"
import script from "./FormularioComponent.vue?vue&type=script&lang=ts&"
export * from "./FormularioComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioComponent.vue?vue&type=style&index=0&id=53b111e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports